<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="checklistTransactions"
      item-key="id"
      sort-by="created"
      sort-desc
    >
      <template v-slot:item.created="{ item }">
        {{ formatDateTime(item.created) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          :to="{ name: 'checklists-Checklist', query: { id: item.id } }"
          small
        >
          <v-icon>
            {{ mdiEye }}
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiEye } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListCheckList',
  mixins: [loading],
  data() {
    return {
      dialog: false,
      mdiEye,
      checklistTransactionName: '',
      headers: [
        { text: 'Start', value: 'created' },
        { text: 'Checklist', value: 'checklist.name' },
        { text: 'State', value: 'state' },
        { text: 'Created By', value: 'createdBy' },
        { text: '', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
    ...mapState('checklistTransactions', ['checklistTransactions']),
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions('checklistTransactions', ['CREATE_checklistTransaction', 'LOAD_checklistTransactions']),
    editChecklistTransaction(checklistTransaction) {
      this.dialog = true;
      this.checklistTransactionName = checklistTransaction.name;
    },
    async saveChecklistTransaction() {
      // save checklistTransaction
      this.isSaving = true;
      const checklistTransaction = { name: this.checklistTransactionName };
      const result = await this.CREATE_checklistTransaction(checklistTransaction);
      this.isSaving = false;
      this.dialog = false;
      this.$router.push({ name: 'checklistTransactions-EditChecklistTransaction', query: { id: result.id } });
    },
    closeDialog() {
      this.dialog = false;
    },
    async refresh() {
      this.isLoading = true;
      await this.LOAD_checklistTransactions();
      this.isLoading = false;
    },
  },
};
</script>
